import * as React from "react";
import Alert from "@mui/material/Alert";
import { AppBar, Box } from "@mui/material";
import { useAuth } from "context";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import MDTypography from "components/MDTypography";

export const NavbarAlert = ({ isProfile }) => {
  const { verifiedCustomer } = useAuth();

  // Preserve localStorage workflow
  const [isVisible, setIsVisible] = React.useState(() => {
    if (verifiedCustomer.verifiedAt && verifiedCustomer.phoneVerifiedAt) {
      return false;
    }
    const alertClosed = localStorage.getItem("navbarAlertClosed");
    return alertClosed !== "true";
  });

  // Update visibility when verification status changes, but respect user's dismiss choice
  React.useEffect(() => {
    if (verifiedCustomer.verifiedAt && verifiedCustomer.phoneVerifiedAt) {
      setIsVisible(false);
    } else {
      // Only show alert if user hasn't dismissed it
      const alertClosed = localStorage.getItem("navbarAlertClosed");
      if (alertClosed !== "true") {
        setIsVisible(true);
      }
    }
  }, [verifiedCustomer.verifiedAt, verifiedCustomer.phoneVerifiedAt]);

  const handleClose = () => {
    setIsVisible(false);
    localStorage.setItem("navbarAlertClosed", "true");
  };

  const getMessage = () => {
    if (!verifiedCustomer?.verifiedAt && !verifiedCustomer?.phoneVerifiedAt) {
      return (
        <>
          Your phone number and email are not verified.
          {!isProfile && (
            <>
              {" Please go to your "}
              <Link to="/profile">
                <MDTypography
                  variant="button"
                  fontWeight="medium"
                  color="info"
                  style={{ textDecoration: "underline", cursor: "pointer" }}
                >
                  profile
                </MDTypography>
              </Link>
              {" to verify them and enjoy uninterrupted access to your rewards!."}
            </>
          )}
        </>
      );
    }
    if (!verifiedCustomer?.verifiedAt) {
      return (
        <>
          Your email is not verified.
          {!isProfile && (
            <>
              {" Please go to your "}
              <Link to="/profile">
                <MDTypography
                  variant="button"
                  fontWeight="medium"
                  color="info"
                  style={{ textDecoration: "underline", cursor: "pointer" }}
                >
                  profile
                </MDTypography>
              </Link>
              {" to verify them and enjoy uninterrupted access to your rewards!."}
            </>
          )}
        </>
      );
    }
    if (!verifiedCustomer?.phoneVerifiedAt) {
      return (
        <>
          Your phone number is not verified.
          {!isProfile && (
            <>
              {" Please go to your "}
              <Link to="/profile">
                <MDTypography
                  variant="button"
                  fontWeight="medium"
                  color="info"
                  style={{ textDecoration: "underline", cursor: "pointer" }}
                >
                  profile
                </MDTypography>
              </Link>
              {" to verify them and enjoy uninterrupted access to your rewards!."}
            </>
          )}
        </>
      );
    }

    return "";
  };

  return (
    <>
      {isVisible && getMessage() && (
        <Box
          sx={{
            marginBottom: "50px",
            "@media (max-width:992px)": {
              marginBottom: isProfile ? "40px" : "120px",
            },
          }}
        >
          <AppBar
            position={"fixed"}
            style={{
              borderRadius: "0",
              marginTop: "0",
              height: "5%",
            }}
          >
            <Alert
              severity="warning"
              onClose={handleClose}
              sx={{
                marginTop: 9,
                marginLeft: 27,
                paddingY: "10px",
                paddingLeft: 3,
                "@media (max-width:992px)": {
                  width: "100%",
                  marginLeft: 0,
                },
              }}
            >
              {getMessage()}
            </Alert>
          </AppBar>
        </Box>
      )}
    </>
  );
};

NavbarAlert.propTypes = {
  isProfile: PropTypes.bool,
};
